import { WixClientDefinition } from '@wix/viewer-service-wix-client/definition'
import type { ServiceDefinition } from '@wix/services-manager/types'

// TODO - remove when implemented and stable in TB
export const noopServiceDefinitions = [WixClientDefinition, 'LinkUtils' as ServiceDefinition<any, any>]

export const noopServicesImpl = () => ({
	getWixClient: () => ({}),
	getImpliedLinks: (html: string) => {
		// Example: wrap all URLs in `<a>` tags (mocked logic)
		const mockProcessed = html.replace(/(https?:\/\/[^\s<]+)/g, (url) => `<a href="${url}">${url}</a>`)
		return mockProcessed
	},
})

export const getNoopServices = () =>
	noopServiceDefinitions.map((definition) => ({
		definition,
		impl: noopServicesImpl,
		config: {},
	}))
